var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { "hide-footer": "" },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function() {
            return [_vm._v("\n    " + _vm._s(_vm.service.name_th) + "\n  ")]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _vm._v(" "),
      _vm.service
        ? _c("div", [
            _c("div", { staticClass: "pb-4" }, [
              _c("img", {
                staticClass: "img-fluid rounded",
                attrs: { src: _vm.service.picture, alt: "" }
              })
            ]),
            _vm._v(" "),
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.service.detail_th) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "pt-2" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-info btn-block",
                  on: {
                    click: function($event) {
                      _vm.showModal = false
                    }
                  }
                },
                [_vm._v("ปิด")]
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-769a03dc", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-769a03dc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/ServiceDetailModal.vue
// module id = 2256
// module chunks = 0